module.exports = __webpack_public_path__ + "b2bef32b87bb41c9914baf964030842e.pdf";


//////////////////
// WEBPACK FOOTER
// ./app/assets/data/competition-rules/rules_fr.pdf
// module id = 935
// module chunks = 1